document.addEventListener("DOMContentLoaded", function () {
  // Upsell add to cart functionality
  const upsellButtons = document.querySelectorAll(
    ".product-upsell--add-to-cart"
  );

  upsellButtons.forEach((button) => {
    button.addEventListener("click", async function (e) {
      e.preventDefault();

      const productHandle = this.dataset.productHandle;

      if (!productHandle) return;

      // Disable button during request
      this.disabled = true;
      const originalHTML = this.innerHTML;
      this.innerHTML = '<div class="spinner"></div>';

      try {
        // Fetch product data to get variant ID
        const productResponse = await fetch(`/products/${productHandle}.js`);
        if (!productResponse.ok) {
          throw new Error("Failed to fetch product");
        }

        const productData = await productResponse.json();
        const firstAvailableVariant = productData.variants.find(
          (v) => v.available
        );

        if (!firstAvailableVariant) {
          throw new Error("No available variant");
        }

        // Add to cart using Shopify AJAX API with variant ID
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: firstAvailableVariant.id,
            quantity: 1,
          }),
        });

        if (response.ok) {
          const cartData = await response.json();

          // Success - update cart count and show feedback
          this.innerHTML = "<span>Added!</span>";
          this.style.background = "#28a745";

          // Dispatch global cart update event
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
            })
          );

          // Trigger cart drawer if it exists
          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer) {
            cartDrawer.open();
          }

          // Reset button after delay
          setTimeout(() => {
            this.innerHTML = originalHTML;
            this.style.background = "";
            this.disabled = false;
          }, 2000);
        } else {
          const errorData = await response.json();
          throw new Error(errorData.description || "Failed to add to cart");
        }
      } catch (error) {
        console.error("Error adding product to cart:", error);

        // Show error state
        this.innerHTML = "<span>Error</span>";
        this.style.background = "#dc3545";

        // Reset button after delay
        setTimeout(() => {
          this.innerHTML = originalHTML;
          this.style.background = "";
          this.disabled = false;
        }, 2000);
      }
    });
  });
});